var React = require('react');

function Turkey (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#E30A17","d":"M44 0H4a4 4 0 00-4 4v24a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4z","key":0}),React.createElement("path",{"fill":"#fff","d":"M17 24a8 8 0 100-16 8 8 0 000 16z","key":1}),React.createElement("path",{"fill":"#E30A17","d":"M19 22.4a6.4 6.4 0 100-12.8 6.4 6.4 0 000 12.8z","key":2}),React.createElement("path",{"fill":"#fff","d":"M23.3 16l7.3 2.4-4.5-6.2v7.6l4.5-6.2-7.3 2.4z","key":3})]);
}

Turkey.defaultProps = {"fill":"none","viewBox":"0 0 48 32"};

module.exports = Turkey;

Turkey.default = Turkey;
